const initialState = {
  addCameraModal: false,
  id: null,
  group_key: null,
  edit: false,
  refresh: false,
  cameraSelected: null,
  cameras: null,
  sidebar: false,
  followingCarOpen: true,
  widget: true,
  activeSaidbarPage: "",
  dataByModel: [],
  radarVideoEffect: null,
  kuzatuvVideoEffect: null
}

const cameraModal = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_CAMERA_MODAL":
      return { ...state, addCameraModal: action?.val?.modal, id: action?.val?.id, group_key: action?.val?.group_key, cameraSelected: action?.val?.camera, edit: action?.val?.edit }
    case "ADDED_CAMERA":
      return { ...state, cameras: action?.val }
    case "SET_SIDEBAR":
      return { ...state, sidebar: action?.val }
    case "SET_WIDGET":
      return { ...state, widget: action?.val }
    case "SET_FOLLOWING_OPEN":
      return { ...state, followingCarOpen: action?.val }
    case "SET_RADAR_VIDEO_EFFECT":
      return { ...state, radarVideoEffect: action?.val }
    case "SET_KUZATUV_VIDEO_EFFECT":
      return { ...state, kuzatuvVideoEffect: action?.val }
    case "SET_DATABYMODEL":
      return { ...state, dataByModel: action?.val }
    case "ADD_CAMERA_REFRESH_DATA":
      return { ...state, refresh: action?.val }
    case "SET_ACTIVESAIDBARPAGE":
      return { ...state, activeSaidbarPage: action?.val }
    default:
      return state
  }
}

export default cameraModal
